import React from "react";
import ForgotPassword from "../components/ForgotPassword";

const ForgotPaaswordPage = () => {
  return (
    <>

      {/* ForgotPaasword */}
      <ForgotPassword/>

    </>
  );
};

export default ForgotPaaswordPage; 